export const LANG_SV = 'sv'
export const LANG_EN = 'en'
export const DEFAULT_LANGUAGE = LANG_SV
